export default __webpack_public_path__ + "static/media/sage.a76dbb69.svg";